import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { DragDropContext, Droppable, DroppableProvided } from '@hello-pangea/dnd';
import Accordion from '../../../../../Accordion';
import LearningCollectionEditStore from '../../../Edit/Store';
import { browseAllContext } from '../../../Types';
import CustomizeTableHead from '../CustomizeTableHead';
import DeletedExperiences from '../DeletedExperiences';
import OnDemandExperiences from '../OnDemandExperiences';

interface Props {
  titleIcon: React.ReactNode;
  title?: AlreadyTranslatedText;
  headerInfo?: React.ReactNode;
  store: LearningCollectionEditStore;
  customizationActions?: React.ReactNode;
  openByDefault: boolean;
  titleJSX?: React.ReactNode;
  countDisplay: React.ReactNode;
}

const OnDemandCustomizeExperiences: React.FC<Props> = ({
  title,
  titleIcon,
  headerInfo,
  store,
  customizationActions,
  openByDefault,
  countDisplay,
  titleJSX,
}) => {
  return (
    <div className="border border-gray-200 mb-2">
      <Accordion
        title={title}
        titleJSX={titleJSX}
        titleIcon={titleIcon}
        headerInfo={headerInfo}
        openByDefault={openByDefault}
        className="flex items-center justify-between bg-white px-7 py-4"
      >
        <div className="overflow-auto border-t-1 border-gray-200 bg-gray-50 px-5 pb-5">
          <div className="flex items-center justify-between">
            <p className="px-2.5 pt-5 text-sm">{countDisplay}</p>
            <div className="px-2.5 pt-5">{customizationActions || <></>}</div>
          </div>
          <table className="mt-4 w-full">
            <thead className="border-b">
              <tr>
                <CustomizeTableHead context={browseAllContext()} store={store} />
              </tr>
            </thead>
            <DragDropContext onDragEnd={store.handleOnDragEndBrowseAll}>
              <Droppable droppableId="characters">
                {(provided: DroppableProvided) => {
                  return (
                    <tbody
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="bg-white"
                    >
                      <OnDemandExperiences learningCollectionStore={store} />
                      {provided.placeholder}
                    </tbody>
                  );
                }}
              </Droppable>
            </DragDropContext>
            <tbody className="bg-white">
              <DeletedExperiences context={browseAllContext()} learningCollectionStore={store} />
            </tbody>
          </table>
        </div>
      </Accordion>
    </div>
  );
};

export default observer(OnDemandCustomizeExperiences);
